import { AuthData, AuthPayload, DeviceLogoutData, DeviceLogoutPayload } from './types'
import client from '../../client'

export const auth = (data: AuthPayload) => client.post<AuthData>('v1/auth/', data)

export const deviceLogout = (data: DeviceLogoutPayload) =>
  client.post<DeviceLogoutData>('v1/devices/logout/', data)
